<template>
  <div class="who-i-owe-widget-container">
    <div v-if="loading" class="who-i-owe-widget-loading">Loading...</div>
    <div v-else-if="error" class="who-i-owe-widget-error">{{ error }}</div>
    <table v-else class="who-i-owe-widget-table">
      <thead>
        <tr>
          <th>Vendor</th>
          <th class="who-i-owe-widget-amount-header">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="vendors.length === 0">
          <td colspan="2" class="who-i-owe-widget-empty">No outstanding bills</td>
        </tr>
        <tr v-else v-for="vendor in vendors" :key="vendor.id">
          <td>{{ vendor.vendorName || vendor.name }}</td>
          <td class="who-i-owe-widget-amount-cell">{{ formatCurrency(vendor.balance) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="vendors.length > 0" class="who-i-owe-widget-footer">
      <router-link :to="{ path: `/company/${companyId}/dashboard/vendors/bills`, query: { view: 'Bills' } }" class="who-i-owe-widget-link">View all bills →</router-link>
    </div>
  </div>
</template>

<script>
import './styles/WhoIOweWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'WhoIOweWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      vendors: [],
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const bills = await ApiService.getBillsAndExpenses(this.companyId, { view: 'Bills' });
        const billsArray = Array.isArray(bills) ? bills : [];
        
        // Group by vendor and sum balances
        const vendorMap = new Map();
        billsArray.forEach(bill => {
          if (bill.voided || !bill.balance || bill.balance <= 0) return;
          
          const vendorId = bill.vendorId;
          const vendorName = bill.vendorName || 'Unknown Vendor';
          
          if (!vendorMap.has(vendorId)) {
            vendorMap.set(vendorId, {
              id: vendorId,
              vendorName: vendorName,
              balance: 0
            });
          }
          
          const vendor = vendorMap.get(vendorId);
          vendor.balance += parseFloat(bill.balance || 0);
        });
        
        this.vendors = Array.from(vendorMap.values())
          .sort((a, b) => b.balance - a.balance)
          .slice(0, 10); // Top 10
      } catch (error) {
        logger.error('Error fetching who I owe data:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

